import React, { Component } from 'react';
import onboarding from 'assets/images/onboarding.png'
import RouteConst from '../../../../constants/RouteConst'
import Button from '../../../atoms/Button/Button'
import { isObjectEmpty } from '../../../../utilities/JSUtil'
import * as FormConst from 'constants/FormConst'
import './Configuration.scss';

export class Configuration extends Component {

    constructor(props) {
        super(props)

        this.state = {
            configurations: {
                'Rate Plans': this.redirectToRatePlanConfigure,
                'Rates': this.redirectToRatesConfigure,
                'Master Boxes': this.redirectToMasterBoxConfigure,
            }
        }
    }

    redirectToRatePlanConfigure = () => {
        this.props.history.push(RouteConst.ROUTE_RATE_PLAN_CONFIGURATION_PAGE)
    }

    redirectToRatesConfigure = () => {
        this.props.history.push(RouteConst.ROUTE_RATES_CONFIGURATION_PAGE)
    }

    redirectToMasterBoxConfigure = () => {
        this.props.history.push(RouteConst.ROUTE_MASTER_BOX_CONFIGURATION_PAGE)
    }

    redirectToSearch = () => {
        this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
    }

    render() {        
        return (
            <div className='configuration-page'>
                <img id='page-logo' src={onboarding} className='onboarding-img' />
                
                <div className='configurations'>
                    <Button 
                        id='back-to-search-page-button' 
                        name='Go to search page' 
                        className='back-to-search-page-button' 
                        onClick={this.redirectToSearch} />

                    <table id='configuration-table' className='table table-striped configuration-table'>
                        <thead>
                            <tr>
                                <th>Configurations</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                !isObjectEmpty(this.state.configurations)
                                    ? (
                                        Object.entries(this.state.configurations).map((config, index) =>
                                            <tr key={index}>
                                                <td>{config[0]}</td>
                                                <td><Button name={FormConst.CONFIGURE_BUTTON_TEXT} role='link' className='icon-link' onClick={config[1]}/></td>
                                            </tr>
                                        )
                                    )
                                    : (
                                        <tr>
                                            <td colSpan={2} className='text-center'>No configurations found.</td>
                                        </tr>
                                    )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default Configuration